<template>
  <div class="order_list">
    <!-- tab -->
    <div class="tabs" style="margin:0 25px;font-size:16px;">
      <div v-for="item in orderList"
           :key="item.key"
           :class="'order-tab-item '+(item.key===dataForm.orderStatus?'tab-item-active':'')"
           @click="changeStatusHandle(item.key)">
        {{item.lable}}
      </div>
    </div>
    <!--  -->
    <el-form :inline="true" :model="dataForm">
      <el-form-item label="单据编号：">
        <el-input v-model="dataForm.orderCode" placeholder="单据编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="制单时间：">
        <el-date-picker type="datetime" placeholder="选择日期" v-model="dataForm.startTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:200px;display:inline-block"></el-date-picker>
        <span style="text-align:center;display:inline-block">-</span>
        <el-date-picker type="datetime" placeholder="选择时间" v-model="dataForm.endTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:200px;display:inline-block"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="butt" type="primary" @click="getDataList(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataLoading"
              :data="dataList"
              border
              style="width: 100%; max-width: 100%;">
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无相关订单">
        <div>暂无相关订单</div>
      </div>
      <el-table-column type="index"
                        label="序号"
                        header-align="center"
                        align="center"
                        width="50"></el-table-column>
      <el-table-column prop="orderCode"
                        label="单据编号"
                        header-align="center"
                        width="110px"
                        align="center"></el-table-column>
      <el-table-column prop="orderStatus"
                        label="状态"
                        header-align="center"
                        align="center"></el-table-column>
      <el-table-column prop="payMoney"
                        label="应付"
                        header-align="center"
                        align="center">
        <template slot-scope="scope">{{scope.row.payMoney|formatePrice}}</template>
      </el-table-column>
      <el-table-column prop="postName"
                        label="支付类型"
                        header-align="center"
                        align="center">默认以合同为准</el-table-column>
      <el-table-column prop="payStatus"
                        label="支付状态"
                        width="80px"
                        header-align="center"
                        align="center"></el-table-column>
      <el-table-column prop="fullAmount"
                        label="付款类型"
                        width="80px"
                        header-align="center"
                        align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fullAmount === true">全款发货</span>
          <span v-else>其他方式</span>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryStatus"
                        label="发货状态"
                        header-align="center"
                        align="center"></el-table-column>
      <!-- <el-table-column prop="createTime"
                        label="平台"
                        header-align="center"
                        align="center"></el-table-column> -->
      <el-table-column prop="createTime"
                        label="创建时间"
                        header-align="center"
                        align="center"></el-table-column>
      <el-table-column :label="$t('handle')"
                        header-align="center"
                        align="center"
                        width="100">
        <template slot-scope="scope">
          <el-dropdown trigger="click"
                        placement="bottom">
            <span class="el-dropdown-link" style="cursor:pointer">
              查看<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item v-if="scope.row.otherSys" @click.native="suposOrderDetail(scope.row)">
                订单详情
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.otherSys" @click.native="suposOrderSubscription(scope.row)">
                服务详情
              </el-dropdown-item> -->
              <el-dropdown-item @click.native="detailOrderHandle(scope.row)">
                查看详情
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.orderStatusCode=='12'" @click.native="confirmOrderHandle(scope.row)">
                确认订单
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.orderStatusCode=='12'" @click.native="confirmPriceChangeHandle(scope.row)">
                申请改价
              </el-dropdown-item>
              <el-dropdown-item v-if="(scope.row.orderSource !== '45'&&Number(scope.row.orderStatusCode) || 29) < 29"
                                @click.native="cancelOrderHandle(scope.row)">
                取消
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.orderStatusCode == '20' && scope.row.payStatusCode == '20'" @click.native="goToPay(scope.row)">
                去支付
              </el-dropdown-item>
              <el-dropdown-item v-if="(scope.row.orderStatusCode=='31'|| scope.row.orderStatusCode=='39' || scope.row.orderStatusCode=='41' || scope.row.orderStatusCode=='49' || scope.row.orderStatusCode=='59')" @click.native="shipmentDetailHandle(scope.row)">
                发货单详情
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.orderStatusCode=='41'" @click.native="orderEvaluateHandle(scope.row)">
                评价
              </el-dropdown-item>
              <el-dropdown-item v-if="(scope.row.orderStatusCode=='49' || scope.row.orderStatusCode == '59') && scope.row.orderEvaluate" @click.native="evaluateLookHandle(scope.row)">
                查看评价
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button type="text"
                      size="small"
                      @click="detailUserHandle(scope.row)">查看</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="dataForm.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="dataForm.limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="getDataList">
    </el-pagination>
    <!-- 改价 -->
    <el-dialog
      title="再次改价"
      :visible.sync="priceChangeVisible"
      width="30%">
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="请输入内容"
        :maxlength="200"
        v-model="priceChangeDataForm.leaveMsg">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="dataLoading" @click="priceChangeVisible=false;priceChangeDataForm.leaveMsg='';">取 消</el-button>
        <el-button :loading="dataLoading" type="primary" @click="confirmPriceChangeSubmitHandle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataLoading: false,
      orderList: [
        {
          key: '0',
          lable: '全部'
        },
        {
          key: '15',
          lable: '待客户确认'
        },
        {
          key: '10',
          lable: '待支付'
        },
        {
          key: '20',
          lable: '待发货'
        },
        {
          key: '30',
          lable: '待收货'
        },
        {
          key: '40',
          lable: '待评价'
        },
        {
          key: '50',
          lable: '订单完成'
        }
      ],
      dataForm: {
        page: 1,
        limit: 10,
        startTime: null,
        endTime: null,
        orderStatus: '0',
        orderCode: ''
      },
      total: 0,
      dataList: [],
      // 确认改价
      priceChangeVisible: false,
      priceChangeDataForm: {
        leaveMsg: '',
        orderId: ''
      }
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 获取列表数据
    getDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      this.$http.post(`/front/consumer/order/myOrderList`, this.dataForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.count || 0
          this.dataList = res.data.data || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改当前订单查询状态
    changeStatusHandle (valueKey) {
      if (this.dataLoading) {
        return false
      }
      if (valueKey === this.dataForm.orderStatus) {
        return false
      }
      this.dataForm.orderStatus = valueKey
      this.dataForm.orderCode = ''
      this.dataForm.startTime = null
      this.dataForm.endTime = null
      this.getDataList(1)
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(0)
    },
    // 查看详情
    detailOrderHandle (row) {
      this.$router.push({
        name: 'orderDetail',
        params: {
          id: row.orderId
        }
      })
    },
    // 确认订单 确认改价
    confirmOrderHandle (row) {
      if (this.dataLoading) {
        return
      }
      this.dataLoading = true
      this.$http.post(`/front/consumer/order/confirmPrice`, {
        orderId: row.orderId
      })
        .then(({ data: res }) => {
          this.dataLoading = false
          if (res.code !== 0) {
            return false
          }
          this.getDataList(1)
        })
        .catch(() => {
          this.dataLoading = false
        })
    },
    // 再次改价
    confirmPriceChangeHandle (row) {
      this.priceChangeDataForm.leaveMsg = ''
      this.priceChangeDataForm.orderId = row.orderId
      this.priceChangeVisible = true
    },
    // 再次改价确认
    confirmPriceChangeSubmitHandle () {
      if (this.dataLoading) {
        return
      }
      this.dataLoading = true
      this.$http.post(`/front/consumer/order/confirmRejectPrice`, this.priceChangeDataForm)
        .then(({ data: res }) => {
          this.dataLoading = false
          if (res.code !== 0) {
            return false
          }
          this.priceChangeVisible = false
          this.getDataList(1)
        })
        .catch(() => {
          this.dataLoading = false
        })
    },
    // 取消订单
    cancelOrderHandle (row) {
      this.$confirm('是否取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataLoading = true
        this.$http.post(`/front/consumer/order/cancelOrder`, {
          orderId: row.orderId
        })
          .then(({ data: res }) => {
            this.dataLoading = false
            if (res.code === 0) {
              this.$message.success(res.message)
              this.getOrderList(1)
            } else {
              return false
            }
          })
          .catch(() => {
            this.dataLoading = false
          })
      })
    },
    // 去支付
    goToPay (row) {
      this.$router.push({
        name: 'orderPay',
        query: {
          id: row.orderId,
          money: row.payMoney,
          virtualAccount: row.virtualAccount
        }
      })
    },
    // 发货单详情
    shipmentDetailHandle (row) {
      this.$router.push({
        name: 'shipmentDetail',
        query: {
          orderId: row.orderId,
          orderCode: row.orderCode,
          orderStatus: row.orderStatus,
          userName: row.userName,
          companyName: row.companyName
        }
      })
    },
    // 订单去评价
    orderEvaluateHandle (row) {
      this.$router.push({
        name: 'orderEvaluate',
        query: { id: row.orderId }
      })
    },
    // 查看订单评价
    evaluateLookHandle (row) {
      this.$router.push({
        name: 'orderEvaluateDetail',
        query: { id: row.orderId }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.order_list{
  .order-tab-item {
    display: inline-block;
    margin-left: 10px;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active{
    color: #1D65A8;
    border-bottom: 2px solid #1D65A8;
  }
}
</style>
